import { Component, ViewChild } from '@angular/core';
import { firstValueFrom, Observable, Subscription, take } from 'rxjs';
import { CatalogPaginationRequest } from 'src/app/features/shared/models/CatalogPagination/CatalogPaginationRequest';
import { FilterRequest } from 'src/app/features/shared/models/Filter/FilterRequest';
import { UserLogsCatalogKeys } from '../../models/UserLogsCatalogKeys';
import { UserLogsService } from '../../services/UserLogs.service';
import { GenericTableComponent } from 'src/app/features/ui/organisms/generic-table/components/generic-table.component';

@Component({
  selector: 'user-logs-list',
  templateUrl: './user-logs-list.component.html',
  styleUrls: ['./user-logs-list.component.css']
})
export class UserLogsListComponent {

  @ViewChild(GenericTableComponent) child;
  
    // columnHeader = {
    //   ip: "IP",
    //   client: "Cliente",
    //   email: "Email",
    //   date: "Ult. Movimiento",
    //   details: "Modulo",
    //   detailList: "Acciones",
    // };
  
     columnHeader : UserLogsCatalogKeys = {
        Ip: { displayName: "IP", filterable: false, activeFilter: null },
        Client: { displayName: "Cliente", filterable: false, activeFilter: null } ,
        Email: { displayName: "Email", filterable: false, activeFilter: null } ,
        Date: { displayName: "Ult. Movimiento", filterable: false, activeFilter: null } ,
        CreatedIn: { displayName: "Fecha", filterable: false, activeFilter: null } ,
        Details: { displayName: "Modulo", filterable: false, activeFilter: null } ,
        // DetailList: { displayName: "Acciones", filterable: false, activeFilter: null }
      };
    
      catalogPaginationRequest: CatalogPaginationRequest = {
        page: 1,
        dato: "",
        getInactive: false,
        filters: []
      }
    
      hasInactives: boolean = false;
      hasEditables: boolean = false;
      hasDeletables: boolean = false;
      filtersRequest : FilterRequest[] = [];
      filterOptions: { [key: string]: string[] } = {};
    
      tableData$: Observable<any[]> = new Observable<any[]>();
      tableData: any[];
      controllerName: string;
      paginador: number;
    
      subscription_getData: Subscription;
      subscription_getDataCount: Subscription;
      subscription_getDataFileterValues: Subscription;
  
    constructor(public userLogsService: UserLogsService) {
      this.controllerName = "Bitacora"
    }
  
    ngOnInit() {
    }
  
    ngOnDestroy(): void {
      this.EndSubscriptions();
    }
  
    EndSubscriptions(){
      if(this.subscription_getData)
        this.subscription_getData.unsubscribe();
      if(this.subscription_getDataCount)
        this.subscription_getDataCount.unsubscribe();
      if(this.subscription_getDataFileterValues)
        this.subscription_getDataFileterValues.unsubscribe();
    }
  
    ngAfterViewInit(){
      this.EndSubscriptions();
      this.getFilters();
      this.getData();
    }
  
    getFilters(){
      var filterKeys = Object.keys(this.columnHeader).filter(key => this.columnHeader[key].filterable);
      this.filtersRequest = filterKeys.map(key => ({
        key: key,
        value: "" 
      }));
    }
  
    async getData(){

      const [getCount, getData] = await Promise.all([
                firstValueFrom(this.userLogsService.getCount(this.catalogPaginationRequest).pipe(take(1))),
                firstValueFrom(this.userLogsService.getPage(this.catalogPaginationRequest).pipe(take(1)))
              ]);
      
      if (getCount.isSuccess) {
        this.paginador = getCount.result[0];
      }
      
      if (getData.isSuccess) {
        this.tableData = getData.result;
        this.tableData.map(item => {
          item['isEditable'] = true;
          if (item['status'] == 'Activo') {
            item['isDeletable'] = true;
          }else{
          item['isDeletable'] = false;
          }
        });
        this.child.setData(this.tableData, this.paginador);
      }
     
      // this.subscription_getDataCount = this.userLogsService.getCount(this.catalogPaginationRequest).subscribe(data=>{
      //   this.paginador = data.result[0];
      //   if(!environment.production) console.log("bitacora datos",this.paginador);
      // },(error)=>{
  
      // });
      // this.subscription_getData = this.userLogsService.getPage(this.catalogPaginationRequest).subscribe(data=>{
      //   if(!environment.production) console.log("bitacora page 1",data);
      //   if(data.isSuccess==true)
      //   {
      //     //Apply condition on edit and delete button
  
  
      //   this.tableData = data.result;
      //   this.tableData.map(item => {
      //     item['isEditable'] = true;
      //     if (item['status'] == 'Activo') {
      //       item['isDeletable'] = true;
      //     }else{
      //     item['isDeletable'] = false;
      //     }
      //   });
      //   this.child.setData(this.tableData, this.paginador);
  
      //   }
      // },(error)=>{
  
      // });
      
    }

}
